/* eslint-disable no-prototype-builtins */
<template>

  <ValidationObserver class="needs-validation form-custom-format " v-bind:class="{'was-validated' : validated}" tag="form" ref="observer">
    <el-dialog title="Generate & Print License Plate No." :visible.sync="dialogVisible" :close-on-click-modal="false" width="40%" size="small" class="text-left filter-form" ref="window" :show-close="!formLoading">

      <mdb-tabs class="table-tabs bts-form-tabs mb-0 form mt-1" :active="active" default :links="tabs" @activeTab="getActiveTabIndex" :key="eventKeyCounter">
              <template :slot="'form-slot'">
                <div class="filter-dalog-body p-2">
                    <ThatsFieldset>
                        <ThatsMultiSelect :show_error="showError" :multiple="false" :clearable="false"  labelClass="col-md-2" fieldClass="col-md-10  pl-0" label="Type" v-model="form.type" :reduce="label => label.value" :reduceLabel="'label'" :options="labelTypesComputed" :rules="'required'" :disabled="disabled" :addButton="false"></ThatsMultiSelect>
                        <ThatsNumber tabindex="18" :labelClass="'col-md-2'" :fieldClass="'col-md-10 pl-0'" label="Quantity" placeholder="Quantity" vid="quantity" name="quantity" v-model="form.quantity" :validated="validated" :rules="'required|min_value:1'" size="sm" />
                    </ThatsFieldset>
                </div>
              </template>
            </mdb-tabs>

            

            <div class="filter-dalog-footer border-top border-light">
                <div class="d-flex align-items-center pr-4 pl-4">

                  <template v-if="formLoading">
                        <mdb-btn color="elegant" size="sm" disabled>
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Loading...
                        </mdb-btn>
                      </template>
                      <template v-else>
                        <mdb-btn color="elegant" class="ml-0" size="sm" @click="onSubmitForm('100x150')"><i class="el-icon-save"></i> 10x15CM LABEL</mdb-btn>
                        <mdb-btn color="elegant" class="ml-0" size="sm" @click="onSubmitForm('50x100')"><i class="el-icon-save"></i> 5x10CM LABEL</mdb-btn>
                        <mdb-btn color="elegant" class="ml-0" size="sm" @click="dialogVisible = false"><i class="el-icon-close"></i> Close</mdb-btn>
                      </template>

                      
                </div>
            </div>

        </el-dialog>
  </ValidationObserver>
</template>
<script>

/*eslint no-prototype-builtins: "error"*/

import { mdbClickOutside,mdbBtn, mdbRow,mdbCol, mdbTabs, mdbInput, mdbContainer, mdbDropdown, mdbDropdownToggle, mdbDropdownMenu} from "mdbvue";

import { ValidationObserver } from "vee-validate";
import { mapActions,mapGetters, mapMutations } from 'vuex'

import { ThatsWindow,ThatsInput, ThatsSeriesInput, ThatsFieldset, ThatsTextarea, ThatsMoney, ThatsMultiSelect, ThatsDatePicker, ThatsNumber} from '../../components/thats/Thats'
import { MessageBox } from 'element-ui';
import XWindow from '../../components/thats/XWindow.vue'
import { Loading } from 'element-ui';

export default {
  directives: {
      mdbClickOutside
    },
  props : {
    group : {
      type : Number,
      default : 2
    }
  },
  inject : ['categoryProvider'],
    components: {
        mdbBtn,
        mdbRow,
        mdbCol,  
        mdbTabs,

        ValidationObserver,
        ThatsWindow, 
        ThatsInput,
        ThatsSeriesInput,
        mdbInput ,
        ThatsFieldset,
        ThatsTextarea,
        ThatsMoney,
        ThatsMultiSelect,
        ThatsDatePicker,
        ThatsNumber,
        XWindow,
        mdbContainer,
        mdbDropdown, mdbDropdownToggle, mdbDropdownMenu
  },
    
  data(){

    const self = this;

    return {

        dialogVisible : false,
        isIndeterminate : false,
        checkAllReceived : false,
        showError : true,
        disabled : false,
        onPasteLoading : false,
        isMaximized : false,
        inputValue : 0,
        validated : false,
        active: 0,
        eventKeyCounter: 0,
        filteredShowroom : [],
        selection : [],
        data : [],
        form : {},
        formLoading : false,
        height: 800,
        width: 900,
        minHeight : 350,
        maxHeight : 800,
        minWidth : 600,
        x : 0,
        y : 0,
        dialogIsOpen : false,

        tabs : [
                { text: 'Details', slot: 'form-slot' },
              ],
        gallery : [],
        categoryOptions : [],
        index : 0
       
    }
  },
    

  created : function() {
        
        this.height = window.innerHeight;
        this.maxHeight = window.innerHeight;
        this.resetForm();
        
  },




  methods: {
    ...mapMutations('WarehouseLabelModule',['setSearchTerm','setFormData','setEmptyForm','setFormStatusCreate']),
    ...mapActions('WarehouseLabelModule',['storeRecord','updateRecord','getRecord']),

    onResize({width,height}){  

       
      },
    resetForm(){
      this.form = JSON.parse(JSON.stringify(this.initialFormObject));
      },
    openDialog(){
        // this.$refs.window.openDialog()

        this.dialogVisible = true
    },
    closeDialog(){
      // this.$refs.window.closeDialog()
      this.dialogVisible = false
    },
    getActiveTabIndex(index){
      this.active = index
    },
    
    
 fnPrintDoc(url) {
            const windowHeight = 900;
            const innerWidth = 600;

            const strWindowFeatures = `location=yes,height=${windowHeight},width=${innerWidth},scrollbars=yes,status=yes`;
            const win = window.open(url, "_blank", strWindowFeatures);
            win.document.title = 'Print';
            win.print();
            if (win) {
                win.onload = () => {
                win.document.title = 'Print';
                win.print();
                };
            } else {
                console.error("Popup blocked or failed to open.");
            }
        },
    onSubmitForm(size){
       const self = this;
       
            self.$refs.observer.validate().then((isValid) => {

              if(isValid){

                
                  self.formLoading = true
                  
                  if(this.formStatus == 'create'){
                    self.storeRecord(self.form).then((res) => {
                      console.log("res", res);
                      console.log(res);
                      if(res.labels){
                        this.fnPrintDoc(`/warehouse-labels/print-barcode?labels=${res.labels}&size=${size}`)
                      }
                      self.showError = false
                      self.formLoading = false
                      self.$ThatsNotify.success({
                          message : "Record successfully added."
                        })
                        self.closeDialog()
                        self.$emit('success')
                    }).catch((error) => {
                        if(error.response.data.hasOwnProperty('errors')){
                          self.$refs.observer.setErrors(error.response.data.errors);
                          self.showError = true
                          self.formLoading = false
                        }
                    })
                  }
                }
            });
    },

    cellClassName(){

    },

     

      dialogState(newState){
        if(!newState){
           
            
            this.resetForm();
          return
        }
        
      },


  },


  beforeDestroy() {
        this.x = ((window.innerWidth) - this.width) / 2
        this.y = (window.innerHeight - this.height) / 2
    },
    beforeMount() {

        this.x = ((window.innerWidth) - this.width) / 2
        this.y = (window.innerHeight - this.height) / 2

    },

  computed: {
    ...mapGetters('WarehouseLabelModule',['getLoading','formData','formStatus','initialFormObject','labelTypes']),
      tblKey : function(){
        return 1;
      },

      labelTypesComputed(){
        return this.labelTypes;
      }
  },
  watch: {
      'formData' : function(v){
        const self = this
        this.eventKeyCounter++
          this.form = JSON.parse(JSON.stringify({...this.initialFormObject,...v}));
          this.$nextTick(()=>{

          
          })
      },



  }

}
</script>

<style lang="scss">



.bts-form-tabs{
    .nav-tabs{
      margin-left: 10px;border-bottom: none!important;
      .nav-item{
        a.active{
          border-bottom: 1px solid #0056b3;
        }
      }
    }

    .tab-content{
      height: auto!important;border-top:1px solid #dee2e6;
    }
}

</style>